import React, { useEffect } from 'react'
import { GlobeIcon } from '@/atoms/Icons/GlobeIcon'
import { useToast } from '@/molecules/Toast'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'

export const TvAuthToast: React.FC<object> = () => {
  const { showToast } = useToast()
  const { query } = useSafeRouter()

  useEffect(() => {
    const TvAuthMessage = 'Congratulations! Your device is now connected.'
    if (query['tv-post-auth'] === 'True') {
      showToast(TvAuthMessage, {
        showInMillis: 10000,
        icon: <GlobeIcon color="white" />,
      })
    }
  }, [showToast, query])

  return null
}
